// extracted by mini-css-extract-plugin
module.exports = {"list":"i_CC"};